import axios from 'axios';

async function createCompanyService(companyId, data) {
  const response = await axios.post(`/companies/${companyId}/services`, data);

  return response.data;
}

async function deleteCompanyService(serviceId, data) {
  const response = await axios.delete(`/services/${serviceId}`, { data });

  return response.data;
}

async function getCompanyServicesByEmployee(companyId, employeeId) {
  const response = await axios.get(`/companies/${companyId}/services?employee_id=${employeeId}`);

  return response.data;
}

async function getSAEAssociationsByAddress(addressId) {
  const response = await axios.get(`/addresses/${addressId}/services/associations`);

  return response.data;
}

async function listCompanyServices(companyId) {
  const response = await axios.get(`/companies/${companyId}/services`);

  return response.data;
}

async function transferServiceAddress(data) {
  const response = await axios.put(`/addresses/services/transfer`, data);

  return response.data;
}

async function updateCompanyService(serviceId, data) {
  const response = await axios.put(`/services/${serviceId}`, data);

  return response.data;
}

async function updateServiceEmployees(serviceId, data) {
  const response = await axios.put(`/services/${serviceId}/employees`, data);

  return response.data;
}

const serviceService = {
  createCompanyService,
  deleteCompanyService,
  getCompanyServicesByEmployee,
  getSAEAssociationsByAddress,
  listCompanyServices,
  updateCompanyService,
  transferServiceAddress,
  updateServiceEmployees,
};

export default serviceService;
